var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "ondigo-multistep-form-wrapper form-step-" + _vm.currentStep },
    [
      _vm.pageDefinitions && _vm.pageDefinitions.length
        ? _c(
            "div",
            { staticClass: "steps-overview-header" },
            _vm._l(_vm.pageDefinitions, function (step, index) {
              return _c(
                "div",
                {
                  key: step.identifier,
                  staticClass: "step-header",
                  class: {
                    "step-active": _vm.currentStep == index + 1,
                    "step-available": _vm.allSteps.length > index,
                  },
                  on: {
                    click: function () {
                      return _vm.setStepIfAvailable(index)
                    },
                  },
                },
                [
                  _c("h2", [_vm._v(_vm._s(index + 1))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(step.label))]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          class:
            "ondigo-multi-step-form ondigo-form form-" +
            _vm.formConfig.identifier,
          attrs: {
            "data-form-identifier": _vm.formConfig.id,
            id: _vm.formConfig.id,
            name: _vm.formConfig.name,
            loading: _vm.loading,
            disabled: _vm.disabled,
          },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleFormSubmit.apply(null, arguments)
            },
          },
        },
        [
          _vm._l(_vm.formConfig.elements, function (element) {
            return _c("dynamic-element", {
              key: element.identifier,
              attrs: { formName: _vm.formConfig.id, element: element },
            })
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errorCountLabel,
                  expression: "errorCountLabel",
                },
              ],
              staticClass: "error-summary input-errors",
            },
            [
              _c(
                "a",
                {
                  attrs: { target: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.scrollToFirstError.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.errorCountLabel))]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formErrors && _vm.formErrors.length,
                  expression: "formErrors && formErrors.length",
                },
              ],
              staticClass: "error-summary form-errors",
            },
            _vm._l(_vm.formErrors, function (error) {
              return _c("p", { staticClass: "error-summary-item" }, [
                _vm._v(_vm._s(error)),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class:
                "d-flex justify-space-between mt-4 btn-row " +
                _vm.nextButtonAlignment,
            },
            [
              _vm.currentStep > 1
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ondigo-btn ondigo-btn-back",
                      attrs: {
                        type: "button",
                        color: "secondary",
                        disabled: _vm.disabled,
                      },
                      on: { click: _vm.loadPreviousStep },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.previousButtonLabel) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLastStep && _vm.componentsMap["SubmitButton"]
                ? _c(_vm.componentsMap["SubmitButton"], {
                    tag: "component",
                    attrs: {
                      loading: _vm.loading,
                      "btn-label": _vm.nextButtonLabel,
                      alignment: _vm.nextButtonAlignment,
                      disabled: _vm.disabled,
                      formName: _vm.formConfig.id,
                    },
                  })
                : _c(
                    "v-btn",
                    {
                      staticClass: "ondigo-btn ondigo-btn-next",
                      attrs: {
                        type: "submit",
                        loading: _vm.loading,
                        color: "primary",
                        disabled: _vm.disabled,
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.nextButtonLabel) + "\n      "
                      ),
                    ]
                  ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }